import { useTypeSelector } from '../useTypeSelector';

export const useMaintenance = () => {
  return useTypeSelector((state) => state.maintenance);
};
